import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const AdminAuthContext = createContext({
  clientAuthInfo: {
    isLoggedIn: false,
    isLoading: true,
    mobileNumber: null,
    accessibilities: null,
    firstName: null,
    lastName: null,
    username: null,
    userId: null,
    baseUserId: null,
    userTypeEnum: null,
    organizationalTitles: null,
  },
  setClientAuthInfo: () => {},
});
export default AdminAuthContext;

export const AdminAuthContextProvider = () => {
  const [clientAuthInfo, setClientAuthInfo] = useState({
    isLoggedIn: false,
    isLoading: true,
    mobileNumber: null,
    accessibilities: [],
    applicatIsLoggedIn: false,
    firstName: null,
    lastName: null,
    username: null,
    userId: null,
    userTypeEnum: null,
    organizationalTitles: null,
    baseUserId: null,
  });

  const context = { clientAuthInfo, setClientAuthInfo };
  return (
    <AdminAuthContext.Provider value={context}>
      <Outlet />
    </AdminAuthContext.Provider>
  );
};
